<!-- <div class="tdashboard-card h-100"> -->
    <div class="card-header-custom" *ngIf="title">
        <div>
            <h5>Todo List</h5>
            <small class="text-muted">
                Manage all your daily work done.
            </small>
        </div>
    </div>
    <div class="row">
        <div class="col-9">
            <input type="text" class="form-control form-control-sm py-1" placeholder="Enter task" [(ngModel)]="task"
                (keyup.enter)="addTask()">
        </div>
        <div class="col-auto">
            <button type="submit" class="btn btn-sm btn-primary mb-3" (click)="addTask()">+Add</button>
        </div>
    </div>

    <div class="stats mb-4" *ngIf="stats">
        <div class="col-4 stat-box">
            <span>{{todos.length}}</span>
            <small>Total</small>
        </div>

        <div class="col-4 stat-box success">
            <span>{{completedCount}}</span>
            <small>Completed</small>
        </div>

        <div class="col-4 stat-box warning">
            <span>{{pendingCount}}</span>
            <small>Pending</small>
        </div>
    </div>

    <div *ngIf="todos.length === 0" class="empty-state">
        <i class="bi bi-journal-check"></i>
        <h5>No Tasks</h5>
        <p *ngIf="stats">Add your first task.</p>
    </div>
    <ul class="list-group mb-0">
        <ng-container *ngFor="let todo of todos">
            <li
                class="list-group-item d-flex justify-content-between align-items-center border-start-0 border-top-0 border-end-0 border-bottom rounded-0">
                <div class="d-flex align-items-center">
                    <input class="form-check-input me-2" type="checkbox" value="" aria-label="..."
                        [checked]="todo.completed" (change)="toggleComplete(todo)">
                    <ng-container *ngIf="!todo.editing">
                        <span class="task-text" [class.completed]="todo.completed">
                            {{todo.title}}
                        </span>
                    </ng-container>
                    <ng-container *ngIf="todo.editing">
                        <input type="text" class="form-control" [(ngModel)]="todo.title" (keyup.enter)="saveEdit(todo)">
                    </ng-container>
                </div>
                <i class="bi bi-x-square-fill text-danger" (click)="deleteTask(todo.id)" style="cursor: pointer;"></i>
            </li>
        </ng-container>
    </ul>
<!-- </div> -->